import { Component, Input, OnInit, Output, EventEmitter, ViewChildren, ElementRef, QueryList } from "@angular/core";

import { BaseComponent, UserService, ExchangeService, environment, HelperService, CommunityService } from "@mypxplat/xplat/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { AppService, WebCommunityService } from "@mypxplat/xplat/web/core";

@Component({
  selector: "myp-add-edit-announcement",
  templateUrl: "add-edit-announcement.component.html",
})
export class AddEditAnnouncementComponent extends BaseComponent implements OnInit {
  @Input() announcement: any;
  @Output() announcementAdded: EventEmitter<any> = new EventEmitter();
  public loading: boolean;
  public preview: boolean = false;
  public pickerDate: any;
  public pickerDateDate: Date;
  public audience: any = {
    web: true,
    mobile: false,
  };
  constructor(
    userService: UserService,
    public activeModal: NgbActiveModal,
    public exchangeService: ExchangeService,
    public helperService: HelperService,
    public appService: AppService,
    public communityService: WebCommunityService
  ) {
    super(userService);
  }

  ngOnInit() {
    if (!this.announcement) {
      this.announcement = {};
      this.pickerDate = {
        day: new Date().getDate(),
        month: new Date().getMonth() + 1,
        year: new Date().getFullYear(),
      };
    } else {
      this.announcement.enDescription = this.announcement.description.en;
      if (this.announcement.audience) {
        this.audience.web = this.announcement.audience.includes("web");
        this.audience.mobile = this.announcement.audience.includes("mobile");
      }
      this.pickerDate = {
        day: (<Date>this.announcement.date.toDate()).getDate(),
        month: (<Date>this.announcement.date.toDate()).getMonth() + 1,
        year: (<Date>this.announcement.date.toDate()).getFullYear(),
      };
    }

    this.setDate();
  }

  setDate() {
    let theDate = new Date();
    theDate.setDate(this.pickerDate.day);
    theDate.setFullYear(this.pickerDate.year);
    theDate.setMonth(this.pickerDate.month - 1);
    theDate.setHours(0);
    theDate.setMinutes(0);
    theDate.setSeconds(0);
    this.pickerDateDate = theDate;
  }

  submit() {
    if (this.announcement.string_id && this.announcement.title && this.announcement.enDescription && (this.audience.web || this.audience.mobile)) {
      if (
        confirm(
          "Are you sure you want to add this announcement? If you click ok, it will be available for every Studio One+ user and will automatically pop up for them if the start date is today or has passed."
        )
      ) {
        let args: any = {
          string_id: this.announcement.string_id,
          title: this.announcement.title,
          date: this.pickerDateDate,
          description: {
            en: this.announcement.enDescription,
          },
        };
        let audience = [];
        if (this.audience.web) audience.push("web");
        if (this.audience.mobile) audience.push("mobile");
        args.audience = audience;
        this.communityService.addAnnouncement(this.announcement.id || this.announcement.string_id, args).then((result) => {
          this.announcementAdded.next(true);
          this.activeModal.close();
        });
      }
    } else {
      alert("Please fill out all the required fields.");
    }
  }
}
